// extracted by mini-css-extract-plugin
module.exports = {"row":"ContentfulFactBlock_row__WLTCH"};